module.exports = __webpack_public_path__ + "static/media/Sponsership.6436f6fd.svg";